import React, { useRef, useState } from 'react'
import { Button, Col, Container, Modal, Row } from 'react-bootstrap'
import loginImg from "../../assets/login (1).png"
import bank from "../../assets/bank.png"
import cash from "../../assets/money.png"
import { useSelector } from 'react-redux'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import CustomBtn from '../CustomBtn/CustomBtn'

function FeesModel(props) {
        const { currentLocal } = useSelector((state) => state.currentLocal);
                const userinfo = useSelector((state) => state);
      const navigate = useNavigate()
            const inputRef = useRef(null);

    const [statex, setState] = useState('')
  const [file, setFile] = useState(null);
        const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
    const handleUpload = async () => {
    if (!file) {
      alert("Please select an image first!");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
setLoading(true)
    try {
      const res = await axios.post(`https://nanosoft.space/taarteb/public/api/student-fees/${props?.feesId}`, {
        payment_method:statex=="cash"?1:2,
        receipt:file
      }, {
        headers: { "Content-Type": "multipart/form-data",
                              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,

         },
      });
setLoading(false)

props.onHide()

    } catch (err) {
      console.error("Upload failed:", err);
      setLoading(false)

    }
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Modal.Body>
  <Container>
         <Row className="px-2">
      
                <Col md={12} className="px-2">
                <div  className="w-100 d-flex justify-content-center mx-3">
                <div className="login_form_section_container d-flex flex-column pt-3  align-items-center"
                    style={{cursor:"pointer"}}

                >
<h4 className='fw-bold mb-4'>{currentLocal.home.Pleasepaytheregistrationformfee} </h4>
<h5 className='fw-bold text-center'>{currentLocal.home.Chooseapaymentmethod} </h5 >
<div className='d-flex'>
    {/* <div
        className='d-flex flex-column mt-3 align-items-center  py-3 px-1 mx-2'
onClick={()=>setState("cash")}
    style={{
                    border:statex=="cash"?"1px solid #e63967":"1px solid #dee2e6"
                  }}
    >
<img src={cash}alt=""className="w-25"/>

        <p className='fs-6 text-center'>{currentLocal.home.Cash}</p>
    </div> */}
    <div
    className='d-flex flex-column mt-3 align-items-center  py-3 px-1 '
           style={{
                    border:statex=="bank"?"1px solid #e63967":"1px solid #dee2e6",
                    cursor: "pointer" 
                  }}
                      onClick={()=>setState("bank")}
    >
        <img src={bank}alt=""className="w-25"/>
  <p className='fs-6'>  
      {currentLocal.home.bankAccount}
</p>
        </div>
</div>
{statex=="bank"?
<div>
<h6 className='mt-3'>{currentLocal.home.Pleasesendtheformfeetomyaccount} </h6>
<p className='mb-1 text-center'>0429004961810012</p>
<p className='fw-bold text-center'>بنك مسقط</p>
<p>{currentLocal.home.Pleasesendthereceipt}</p>
    <div>

      {/* Hidden file input */}
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {/* Custom button to trigger file input */}
<div
style={{border:"1px dashed #000",height:"150px",justifyContent:"center",alignItems:"center",display:"flex",width: "350px",}}
onClick={() => inputRef.current.click()}
>
    {file?
            <div>
          <img
            src={URL.createObjectURL(file)}
            alt="preview"
            style={{ height:  "150px"}}
          />
        </div>
    :
    <>
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
  <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
  <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
</svg>    </>
    }
    
    </div>



    </div>



    </div>
:
<>
<p className='mt-4'>{currentLocal.home.Pleasesendthereceipt}</p>
    <div>

      {/* Hidden file input */}
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {/* Custom button to trigger file input */}
<div
style={{border:"1px dashed #000",height:"150px",justifyContent:"center",alignItems:"center",display:"flex",width: "350px",}}
onClick={() => inputRef.current.click()}
>
    {file?
            <div>
          <img
            src={URL.createObjectURL(file)}
            alt="preview"
            style={{ height:  "150px"}}
          />
        </div>
    :
    <>
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
  <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
  <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
</svg>
    </>
    }
    
    </div>



    </div>
</>
}
<div className='mt-4 w-100 mx-3'>
<div className='d-flex  justify-content-center align-items-center'>
                        <CustomBtn text={loading ? currentLocal.home.Loading:currentLocal.home.send} disabled={loading}type={"submit"}clickingFunction={handleUpload} />

</div>
</div>
                
                {/* <SignupForm/> */}
                    </div>
                </div>
                </Col>
            </Row>
  </Container>
      </Modal.Body>

    </Modal>
  )
}

export default FeesModel